import { SVGProps } from 'react';
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='https://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    className='instagram_svg__feather instagram_svg__feather-instagram'
    aria-labelledby='instagramTitle'
    {...props}
  >
    <title id='instagramTitle'>Instagram Logo</title>
    <rect x={2} y={2} width={20} height={20} rx={5} ry={5} />
    <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37zM17.5 6.5h.01' />
  </svg>
);
export default SvgInstagram;
